import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { CategorieProduit } from 'src/app/shared/models/categorie';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-update-categore',
  standalone: false,
  templateUrl: './update-categore.component.html',
  styleUrl: './update-categore.component.scss'
})

export class UpdateCategoreComponent {
  item: CategorieProduit = new CategorieProduit();
  departementItems: any;
  categorieProduitItems: any;
  adminItems: any;
  user_reference: any;
  etatProduitItems: any;
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;
  items:any;
  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.user_reference = this.localStorage.getUsers();
    console.log("this.user_reference", this.user_reference);
    this.items = this.localStorage.getCategorieMarket();
    this.item = this.items;
  }



  close() {

    this.modalService.dismissAll();
  }

  updteCategorie() {
    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: this.item.getErrorMessage() });
    //   return;
    // }
  //  else {
      this.ngxservice.start();
      this.paramService.updateCategorieMarket(this.items.reference,this.item).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "Président de coopérative",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "Ikena Cooperative",
            detail: error,
          });
        }
      );
    //}
  }


}
